import {
	PHARMACY_PATIENT_ADD_NOTE_REPLY_REQUEST,
	PHARMACY_PATIENT_ADD_NOTE_REPLY_SUCCESS,
	PHARMACY_PATIENT_ADD_NOTE_REPLY_FAILURE
} from '../../../constants';

import { userProfile } from '../../../../constants/rootReduceName';
import { pharmacy_patient_notes_reply } from '../../../../networking/urlEndPoints'
import { updatePatientNote } from './pharmacyPatientNotifications';

import Axios from '../../../../networking/intraceptor'
import { formatDateTimeCanada } from '../../../../utils/helper/helper';

export const addPatientNoteReplyRequest = () => ({
	type: PHARMACY_PATIENT_ADD_NOTE_REPLY_REQUEST,
});

export const addPatientNoteReplySuccess = (data) => ({
	type: PHARMACY_PATIENT_ADD_NOTE_REPLY_SUCCESS,
	payload: data,
});

export const addPatientNoteReplyFailure = (error) => ({
	type: PHARMACY_PATIENT_ADD_NOTE_REPLY_FAILURE,
	payload: error,
});

export const addPatientNoteReply = (id, addnotes, page, addTeamNoteData, setAddTeamNoteData, value, useInfiniteScroll = false) => {
	return async (dispatch, getState) => {
		dispatch(addPatientNoteReplyRequest());
		try {
			const response = await Axios.post(`${pharmacy_patient_notes_reply}`, {
				note: addnotes,
				note_id: id
			})

		if (response?.status === 200) {

			dispatch(addPatientNoteReplySuccess(response?.data));
			
			// Immediately add reply to local state so UI updates instantly
			// Try to get reply from API response, fallback to constructing from current user
			let newReply = response?.data?.data?.reply;
			if (!newReply) {
				// Construct reply from current user profile if API doesn't return it
				const state = getState();
				// Use the correct Redux state key (userProfile is an encrypted constant)
				const profileData = state?.[userProfile]?.profileData?.data;
				newReply = {
					notes: addnotes,
					added_by: profileData?.name || '',
					added_by_photo: profileData?.photo || profileData?.thumbnail || '',
					date_time: formatDateTimeCanada(new Date().toISOString())
				};
			}
			dispatch(updatePatientNote(id, newReply, 'addReply'));

			if (typeof setAddTeamNoteData === "function") {
				setAddTeamNoteData({
					...addTeamNoteData,
					addReply: '',
				})
			}

		} else {
			throw new Error(response);
		}
		} catch (error) {
			if (error?.response) {
				dispatch(addPatientNoteReplyFailure(error?.response));
			}
		}
	}
}

